

import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity UserAddresses


export interface UserAddress {
    id: ID;

    
    userId: ID;

    
    addressId: ID;

    }




export interface CreateUserAddress {
    
    userId: ID;

    
    addressId: ID;

    }





export class PrimaryUserAddress {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: UserAddress): PrimaryUserAddress | undefined {
        return entity ? new PrimaryUserAddress(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryUserAddress {
        return new PrimaryUserAddress(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryUserAddress {
        let vals = path?.split('/');
        return new PrimaryUserAddress(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryUserAddress[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: UserAddress): string {
    let fields = entity ? [
    entity.userId,
            entity.addressId,
            ] : [];
    return fields.filter(item => item).join(' | ');
}


